import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'
import { LINE_BOARD } from 'frontend/constants/callers'
import {
  LINE_BOARD_KPI_CARD_DETAILS_NAME,
  LINE_BOARD_MANAGEMENT_DETAILS_ROUTE_NAME,
} from 'frontend/routes/constants'
import { SFM_SOURCES } from 'frontcore/presentation/comments/types'

const BoardIndicatorNavigationOnModule = () => import('frontend/presentation/board-indicator-navigation-on-module/BoardIndicatorNavigationOnModule.vue')
const LineBoardPage = () => import('frontend/pages/lineBoard/LineBoardPage/LineBoardPage.vue')
const LineBoardOverview = () => import('frontend/pages/lineBoard/LineBoardOverview/LineBoardOverview.vue')
const LineBoardNavigationOnModule = () => import('frontend/presentation/line-board-navigation-on-module/LineBoardNavigationOnModule.vue')
const SFMDetails = () => import('frontend/pages/shopFloorManagement/SFMDetails/SFMDetails.vue')
const SFMKPICardDetails = () => import('frontend/pages/shopFloorManagement/SFMKPICardDetails/views/SFMKPICardDetails.vue')

export default [
  {
    name: 'line-board-root',
    path: '/line-board',
    component: LineBoardPage,
    redirect: {
      name: DASHBOARD_MODULE_TOKENS.lineBoard.name,
    },
    children: [
      {
        shownInMenu: true,
        path: 'overview',
        name: DASHBOARD_MODULE_TOKENS.lineBoard.name,
        components: {
          header: LineBoardNavigationOnModule,
          default: LineBoardOverview,
        },
        props: {
          header: {
            showPerimeterFinder: true,
            caller: LINE_BOARD,
            isVisibleRightSection: true,
            isVisibleShiftSelector: true,
          },
        },
      },
      {
        shownInMenu: false,
        path: 'topic/:topicId/:perimeterId?/details',
        name: LINE_BOARD_MANAGEMENT_DETAILS_ROUTE_NAME,
        components: {
          header: LineBoardNavigationOnModule,
          default: SFMDetails,
        },
        props: {
          default: (routerInstance) => {
            return {
              topicId: Number(routerInstance.params.topicId),
              perimeterId: routerInstance.params.perimeterId ? Number(routerInstance.params.perimeterId) : undefined,
              boardSource: SFM_SOURCES.LINE_BOARD,
              routeToGoBack: DASHBOARD_MODULE_TOKENS.lineBoard.name,
            }
          },
          header: {
            routeToGoBack: DASHBOARD_MODULE_TOKENS.lineBoard.name,
            hasPerimeterIntoPath: true,
          },
        },
      },
      {
        shownInMenu: false,
        path: 'indicator/:id/:perimeterId?',
        name: LINE_BOARD_KPI_CARD_DETAILS_NAME,
        components: {
          default: SFMKPICardDetails,
          header: BoardIndicatorNavigationOnModule,
        },
        props: {
          default: (routerInstance) => {
            return {
              indicatorId: Number(routerInstance.params.id),
              boardSource: SFM_SOURCES.LINE_BOARD,
            }
          },
          header: {
            hasPerimeterIntoPath: true,
          },
        },
      },
    ],
  },
]
